<template>
  <div class="map-wrapper">
    <div id="map">
      <div class="map-button-wrapper">
        <div class="map-button-inner green-border">
          <v-select
            v-model="selectedZone"
            class="filter-input2"
            label="DSO Zone" id="zone" name="zone"
            hide-details
            color="#58c26d"
            @change="changeZone()"
            :items="zones"
            item-text="zoneName"
            item-value="zoneCode"
            dense
            outlined
          ></v-select>
          <v-select
            v-model="selectedLocation"
            class="filter-input2"
            label="Location" id="location" name="location"
            hide-details
            color="#58c26d"
            @change="changeLocation()"
            :items="locations"
            item-text="locationName"
            item-value="locationCode"
            dense
            outlined
          ></v-select>
      <!-- 
          <v-menu
            ref="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                class="filter-input2"
                hide-details
                color="#58c26d"
                v-model="date"
                v-on="on"
                label="Date"
                append-icon="mdi-menu-down"
                dense
                outlined
              ></v-text-field>
            </template>
            <v-date-picker
              ref="picker"
              color="#329e5e"
              @input="(e) => changeFilterDate(e)"
            ></v-date-picker>
          </v-menu>
          <v-menu
            ref="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                class="filter-input2"
                label="Time"
                v-model="time"
                hide-details
                color="#58c26d"
                append-icon="mdi-menu-down"
                dense
                outlined
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              ref="tpicker"
              color="#329e5e"
              @input="(e) => changeFilterTime(e)"
            ></v-time-picker>
          </v-menu>
          <v-text-field
            class="filter-input2"
            label="Volume"
            v-model="volume"
            hide-details
            color="#58c26d"
            type="number"
            min="0"
            dense
            outlined
          ></v-text-field> 
      -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ZoneDataService from "../../services/ZoneDataService";
import LocationDataService from "../../services/LocationDataService";

export default {
  props: ["map", "matching"],
  data() {
    return {
      accessToken:
        "pk.eyJ1IjoiamFycm9keWVsbGV0cyIsImEiOiJjazZieHI5NXEwNGUwM2ptc3F4ejZ6MmJ5In0.5zZ0n1qoedqjHeuNllLYPw", // your access token. Needed if you using Mapbox maps
      mapStyle: "mapbox://styles/jarrodyellets/ck6byoqcp4k5e1is4565r4vl8", // your map style
      coordinates: [24.873046874999996, 45.874712248904764],
      zoom: 6,
      //location: ["Bugaria"],
      location: ["Romania"],
      zones: [],
      locations: [],
      region: [],
      date: "",
      time: "",
      volume: "",

      selectedZone: null,
      selectedLocation: null,
    };

  
  },
  methods: {
    changeFilterTime(e) {
      this.time = e;
    },
    changeFilterDate(e) {
      this.date = e;
    },

    retrieveZones() {
      //ZoneDataService.findByCountryCode(this.$store.state.auth.user.countryCode)
      ZoneDataService.findByCountryCode("RO")
        .then((response) => {
          this.zones = response.data;
          console.log("HERE... retrieve zones sucessfull: " + response.data);
        })
        .catch((e) => {
          console.log("HERE... retrieve zones error: " + e);
        }); 
    },

    retrieveLocations() {
      console.log("HERE... call retrieveLocations");
      LocationDataService.findByCountryCode(this.selectedZone)
        .then((response) => {
          this.locations = response.data;
          console.log("HERE... retrieve locations sucessfull: " + response.data);
        })
        .catch((e) => {
          console.log("HERE... retrieve locations error: " + e);
        }); 
    },

    changeZone() {
      console.log("Selected zone: ", this.selectedZone)
      this.$parent.changeDSOZone(this.selectedZone);
      this.retrieveLocations();
      this.selectedLocation = this.locations[0].locationCode;
    },

    changeLocation() {
      console.log("Selected location: ", this.selectedLocation);
      this.$parent.changeState(this.selectedLocation);
    },

  },

  /* mounted: function () {
    //this.retrieveZones();

  
    if (this.$store.state.auth.user.countryCode === "BG") {
      this.zones=[
        {
          zoneCode: "BGDSO01",
          zoneName: "CEZ Area",
        }
      ],
      this.selectedZone = "BGDSO01";
      this.selectedLocation = "073"
    } 
    if (this.$store.state.auth.user.countryCode === "TR") { 
      this.zones= [
        {
          zoneCode: "TRDSO16",
          zoneName: "OEDAS - Osmangazi",
        },
      ],
      this.selectedZone = "TRDSO16";
      this.selectedLocation = "228"
    } 

    this.retrieveLocations();
    this.$nextTick(function () {
      
      // Code that will run only after the entire view has been rendered
    });
  }, */

  mounted() {

    this.$store.state.auth.user.countryCode == "RO";

    console.log("HERE... test Network Map");
    this.retrieveZones();
    this.retrieveLocations();

    for (let match of this.matching) {
      if (this.region.indexOf(match.locationName) === -1) {
        this.region.push(match.locationName);
      }
    }
    this.region = this.region.sort();
  },
};
</script>
<style lang="scss">
#map {
  height: 100%;
  position: relative;
}

.map-button-wrapper {
  position: absolute;
  top: 20px;
  left: 50%;
  z-index: 2;
}

.map-button-inner {
  padding: 5px;
  background-color: #fff;
  border-radius: 5px;
  position: relative;
  left: -50%;
  display: flex;
}

.map-button-inner .theme--light.v-input,
.map-button-inner .theme--light.v-input input,
.map-button-inner .theme--light.v-input textarea,
.map-button-inner .v-text-field--outlined fieldset {
  border-width: 2px !important;
}

.map-wrapper {
  height: 100%;
}
.mapboxgl-canvas-container {
  height: calc(100vh - 50px) !important;
}
.mapboxgl-canvas {
  width: 100% !important;
}

.mapboxgl-control-container {
  display: none;
}

.filter-input2 {
  margin: 5px !important;
  min-width: 150px;
}
</style>